import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase} from "@mui/material";
import TableSearch from "../../components/TableSearch";
import CustomPieChart from "../../components/CustomPieChart";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {useEffect, useState} from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import {API_ENDPOINT_URL} from "../../util/api";
import { getLocalItem } from "../../util/helper";
import {PieChart} from "../../components/PieChart";
import { toast } from 'react-toastify';

const timezone = 'Asia/Tokyo';

const columns = [
    {
      field: "domain",
      headerName: "Domain",
      flex: 1,
      cellClassName: "name-column--cell"
    },
    {
      field: "url",
      headerName: "URL",
      flex: 1
    },
    {
      field: "brand",
      headerName: "Brand",
      flex: 1
    },
    {
      field: "score",
      headerName: "Score",
      flex: 1
    },
    {
      field: "is_alive",
      headerName: "isAlive",
      flex: 1
    },
    {
      field: "html",
      headerName: "HTML",
      flex: 1
    },
    {
      field: "scsh",
      headerName: "SCSH",
      flex: 1
    },
    {
      field: "subject_o",
      headerName: "Cert Owner",
      flex: 1
    },
    {
      field: "not_before",
      headerName: "Not Before",
      flex: 1
    },
    {
      field: "message_type",
      headerName: "Message Type",
      flex: 1

    },
    {
      field: "created",
      headerName: "Created",
      flex: 1
    },
  ];


const Report = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [validateDate, setValidateDate]= useState(false);
  const [validateStartDate, setValidateStartDate]= useState(false);
  const [validateEndDate, setValidateEndDate]= useState(false);
  const [validateText, setValidateText]= useState("");
  const [loading, setLoading]= useState(false)
  const token = getLocalItem("key")

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setValidateDate(false);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setValidateDate(false);
  };

  const [data, setData] = useState([]);

  useEffect(()=>{
    if (!startDate || !endDate) {
      // setValidateText('Both start and end dates are required.')
      setValidateDate(true);
      setValidateStartDate(!startDate)
      setValidateEndDate(!endDate)
      setValidateText('')
    }
    else if (startDate&&endDate){
        const diffDate = startDate.diff(endDate, 'days') 
        const valid = diffDate<=0?false:true
        if (valid){
          setValidateText('End date must be greater than the Start date.')
        }
        setValidateStartDate(!startDate)
        setValidateEndDate(!endDate)
        setValidateDate(valid)
    }
    else{
      setValidateDate(false)
    }
  },[startDate, endDate])


  const handleSearch = async (searchParams) => {
    let params = {};
    if (!validateDate) {
      if (startDate) {
        params.begin_date = moment
          .utc(startDate.toISOString())
          .tz(timezone)
          .format("YYYY/MM/DD");
      }
      if (endDate) {
        params.end_date = moment
          .utc(endDate.toISOString())
          .tz(timezone)
          .format("YYYY/MM/DD");
      }
      const { searchText, currentPage, sort } = searchParams;

      params.search = searchText;
      params.page = currentPage;
      params.ordering = `${sort.order}${sort.column}`;
      setLoading(true);

      try {
        const response = await axios.get(`${API_ENDPOINT_URL}/data/list/`, {
          params,
          headers: { Authorization: `Bearer ${token}` },
          timeout: 60000,
        });
        setData(response.data);
      } catch (error) {
        setData([]);
        console.clear();
        toast.warn(
          "検索対象データが多すぎますので、ドメインまたはブランドの条件を追加して再検索してください。",
          {
            position: "top-right",
            style: {
              width: "100%",
              maxWidth: "100%",
            },
          }
        );
      } finally {
        setLoading(false);
      }
    }
  };
  
  return (
    <Box
      mt="50px"
      sx={{
        // backgroundColor: "red",
        width: "95%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          //   backgroundColor: "yellow",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Grid container spacing={0}>
          <Grid item lg={6} sm={12} md={6}>
            <Box>
              <Typography
                variant="h1"
                fontSize={40}
                fontWeight="bold"
                color="#2699fb"
                textAlign="left"
              >
                URLs/Brands Report
              </Typography>
            </Box>
            <Box mt={4}>
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="body1" fontSize={20} color="#707070">
                    Valid Url Rate
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "160px",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      {data?.url_rate && data.url_rate.length > 0 ? (
                          <PieChart data={data?.url_rate}/>
                      ) : (
                        <p>No data available</p>
                      )}
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" fontSize={20} color="#707070">
                    Detect Brands Rate
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "160px",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      {data?.brands && data.brands.length > 0 ? (
                          <PieChart data={data?.brands}/>
                      ) : (
                        <p>No data available</p>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item lg={1} sm={0} md={0}></Grid>
          <Grid item lg={5} sm={12} md={6}>
            <Box
              sx={{
                // width:"100%",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Typography
                  mr={1}
                  variant="body1"
                  fontSize={20}
                  color="#707070"
                >
                  Date:
                </Typography>
                <DatePicker
                  value={startDate}
                  onChange={handleStartDateChange}
                  label="Start Date *"
                  format="YYYY/MM/DD"
                  slotProps={{ actionBar: { actions: ['today', 'clear',] }}}
                  sx={{
                    ...(validateStartDate && {
                      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid red',
                      },
                    }),
                  }}
                />
                <Typography variant="body1" m={1} fontSize={20} color="#707070">
                  ~
                </Typography>
                <DatePicker
                  value={endDate}
                  onChange={handleEndDateChange}
                  label="End Date *"
                  format="YYYY/MM/DD"
                  slotProps={{ actionBar: { actions: ['today', 'clear'] }}}
                  sx={{
                    ...(validateEndDate && {
                      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid red',
                      },
                    }),
                  }}
                />
                
              </LocalizationProvider>
            </Box>
            {validateDate && (
              <Typography sx={{ color: 'red' }}>
                  {validateText}
              </Typography>
            )}
          </Grid>
        </Grid>
        {data ? (
          <Box mt={5} width="100%">
            <TableSearch
              rows={data.results}
              columns={columns}
              totalPage={data.last_page_number}
              onSearch={handleSearch}
              loading={loading}
            />
          </Box>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
  );
};

export default Report;
